<!-- <nav id="thefooter" class="navbar navbar-custom navbar-expand-lg">
  <div >
    <div>&copy; University of New England</div>
  </div>

  <ul class="navbar-nav ml-auto footer-nav">
    <li class="nav-item"><a  routerLinkActive="active" routerLink="/terms-conditions">Customer Licence Agreement</a> | </li>
    <li class="nav-item"><a routerLinkActive="active" routerLink="/privacy">Privacy Policy</a> | </li>
    <li class="nav-item"><a routerLinkActive="active" routerLink="/disclaimer">Terms of Use</a></li>
  </ul>
</nav>
 -->
<div id="thefooter" class="d-none d-sm-none d-md-block">
  <div class="row">
    <div class="col-4 centre">
      <a routerLink="/home-logged-out">
        <img class="footer-logo" src="assets/images/CASI_Logo_Lge.png">
      </a>

    </div>
    <div class="col-8 centre"><span class="flesh-it">If you’d like to learn more about CASI or would like to discuss
        an opportunity to work with us, please
        <a routerLinkActive="active" routerLink="/contact-us" style="color:white; text-decoration: underline"> contact
          us.</a></span>
    </div>
  </div>

</div>

<div id="thefooter" class="d-none d-sm-block d-md-none">
  <div class="row">
    <div class="col-4 centre">
      <a  routerLink="/home-logged-out">
        <img class="footer-logo" src="assets/images/CASI_Logo_Lge.png">
      </a>

    </div>
    <div class="col-8 centre"><span class="flesh-it">If you’d like to learn more about CASI or would like to discuss
        an opportunity to work with us, please
        <a routerLinkActive="active" routerLink="/contact-us" style="color:white; text-decoration: underline"> contact
          us.</a></span>
    </div>

  </div>
</div>

<div id="thefooter" class=" d-block d-sm-none">
  <div class="row centre"><span class="flesh-it">If you’d like to learn more about CASI or would like to discuss
      an opportunity to work with us, please
      <a routerLinkActive="active" routerLink="/contact-us" style="color:white; text-decoration: underline"> contact
        us.</a></span>
  </div>
  <div class="row centre" style="text-align: center">
    <a  routerLink="/home-logged-out">
      <img class="footer-logo" src="assets/images/CASI_Logo_Lge.png">
    </a>
  </div>

</div>
